import { Button, Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface AuditLogsLoadMoreProps {
  isLoading: boolean
  onLoadMore: () => void
}

export function AuditLogsLoadMore({
  isLoading,
  onLoadMore,
}: Readonly<AuditLogsLoadMoreProps>) {
  const { t } = useTranslation('features', { useSuspense: false })

  return (
    <Flex justify="center" pt={4}>
      <Button
        variant="outline"
        size="sm"
        colorPalette="gray"
        loading={isLoading}
        onClick={onLoadMore}
      >
        {t('auditLogs.loadMore')}
      </Button>
    </Flex>
  )
}
